import Button from "@/components/ui/Button";
import Dropdown from "@/components/ui/DropDown";
import TextField from "@/components/ui/Textfield";
import { PlusIcon } from "lucide-react";
import { JSX } from "react";
import { useAdCategoryStore } from "../store/adCategoryStore";
import { useShallow } from "zustand/react/shallow";

export default function CreateAdCategoriesStepThree(): JSX.Element {
  const { addAdType, updateAdInput, publishers } =
    useAdCategoryStore(
      useShallow((state) => ({
        addAdType: state.addAdType,
        updateAdInput: state.updateAdInput,
        publishers: state.publishers,
      })),
    );

  const adTypes = useAdCategoryStore((state) => state.adTypes);

  return (
    <div className="mt-6">
      <div className="font-bold text-xl mb-6">
        Assign Ad Types to{" "}
        {adTypes[0]?.publisher || publishers[0]?.name || "[Publisher]"}
      </div>
      <hr className="border-[#EA33C0] mb-6" />
      {adTypes.map((adType, index) => (
        <div key={index}>
          <div className="mb-2">
            <span className="font-bold">Publisher: </span>
            {adType.publisher || "User Defined"}
          </div>
          {adType.adInputs.map((adInput, index1) => (
            <div className="flex w-full mt-3 items-center" key={index1}>
              <div className="w-2/3 pr-5 flex items-center">
                <div className="w-full">
                  <div className="text-gray-500 text-sm mb-1">Ad Types</div>
                  <TextField
                    type="text"
                    placeholder="Ad Type Name"
                    className="w-full"
                    value={adInput?.name || ""}
                    onChange={(ee) =>
                      updateAdInput(index, index1, "name", ee.target.value)
                    }
                  />
                </div>
              </div>
              <div>
                <div className="text-gray-500 text-sm mb-1">Media Type</div>
                <Dropdown
                  options={[
                    { title: "Print", value: "print" },
                    { title: "Digital", value: "digital" },
                    { title: "Broadcast", value: "broadcast" },
                    { title: "Outdoor Digital", value: "outdoor_digital" },
                  ]}
                  selected={adInput?.mediaType || ""}
                  setSelected={(value) =>
                    updateAdInput(index, index1, "mediaType", value.toString())
                  }
                  className="w-60"
                />
              </div>
            </div>
          ))}
          <div className="mt-4">
            <Button
              type="secondary"
              leadingIcon={<PlusIcon />}
              onClick={() => addAdType(index)}
            >
              Add Ad Type
            </Button>
          </div>
          {index != adTypes.length - 1 && (
            <hr className="my-5 border-1 border-gray-300" />
          )}
        </div>
      ))}
    </div>
  );
}
